import { IPaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { IGeneratedRecoveryCode, IGeoLocationData, ILegacyAppUser, IOrgPasskeySettings, IPaginatedWhitelistResponse, IPasskey, IRecoveryCode, IRequestDataForIP } from  "@/interfaces/passkeys";
import { container, TYPES } from  "@/inversifyconfig/container.config";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 
export async function listMyPasskeys(skip?: number): Promise<IPaginatedResponse<IPasskey>> {
    const url = `passkeys?skip=${skip ?? 0}`   

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get passkey data`))
}

export async function listPasskeysForUser(userId: number, skip: number): Promise<IPaginatedResponse<IPasskey>> {
    const url = `users/${userId}/passkeys?skip=${skip}`;

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get passkey data`))
}

export async function listRecoveryCodesForUser(userId: number, skip: number): Promise<IPaginatedResponse<IRecoveryCode>> {
    const url = `users/${userId}/account/recovery/codes?skip=${skip}`;

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get recovery code data`))
}

export async function listRecoveryRequestsForUser(userId: number, params: any, options?: { signal?: AbortSignal }): Promise<IPaginatedResponse<IRecoveryCode>> {
    const url = `users/${userId}/account/recovery/requests`

    const res = await http.get(url, { params: params, signal: options?.signal});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get recovery code data`))
}

export async function listRecoveryRequestsForIP(userId: number, ipAddress: string, params: any, options?: { signal?: AbortSignal }): Promise<IPaginatedResponse<IRequestDataForIP>> {
    const url = `users/${userId}/account/recovery/requests/ip/${ipAddress}`

    const res = await http.get(url, { params: params, signal: options?.signal});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get recovery code data`))
}

export async function listWhitelistAddressesForUser(userId: number, skip: number): Promise<IPaginatedWhitelistResponse<any>> {
    const url = `users/${userId}/account/recovery/ip?skip=${skip}`;

    const res = await http.get(url);
    
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get whitelist IP address data`))
}

export async function listLegacyAppUsers(orgId: string, params: any): Promise<IPaginatedResponse<ILegacyAppUser>> {
    const url = `organization/${orgId}/users/legacyPasskeyUsers` 

    const res = await http.get(url, {params: params || {}});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get user data`))
}

export async function getPasskeySettingsForOrg(orgId: string): Promise<IOrgPasskeySettings> {
    const url = `organization/${orgId}/settings/passkeys`    

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get user data`))
}

export async function getApproximateLocation(ipAddress: string): Promise<IGeoLocationData> {
    const url = `ip/${ipAddress}`     

    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get geo location data`))
}

export async function generateRecoveryCodeForUser(userId: string) : Promise<IGeneratedRecoveryCode> {
    const url = `users/${userId}/account/recovery/codes`     
    
    const res = await http.post(url, {});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't generate a code`))      
}
export async function setPasskeySettingsForOrg(orgId: string,  passkeysEnabled:boolean, forcePasskeysEnabled: boolean): Promise<any> {
    const url = `organization/${orgId}/settings/passkeys `     

    const payload = {
        "PasskeySignInEnabled": passkeysEnabled,
        "ForcePasskeySetupEnabled": forcePasskeysEnabled
    }
    const res = await http.post(url, payload);

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't set user data`))
}

export async function revokeAccountRecoveryCodes(userId: number) {
    const url = `users/${userId}/account/recovery/codes`;

    const res = await http.delete(url);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't revoke account recovery codes`))
}

export async function addWhitelistIpAddress(userId: number, payload: any) {
    const url = `users/${userId}/account/recovery/ip`;

    const res = await http.post(url, payload);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't add ip address to whitelist`))
}

export async function removeWhitelistIpAddress(userId: number, ipAddressId: number) {
    const url = `users/${userId}/account/recovery/ip/${ipAddressId}`;

    const res = await http.delete(url);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't add ip address to whitelist`))
}

export async function setUserRecoveryIPRestriction(userId: number, payload: any) {
    const url = `users/${userId}/account/recovery/ip/restriction`;

    const res = await http.put(url, payload);
    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Couldn't update restriction settings`))
}

export async function deletePasskey(passkeyId: number) {
    const url = `passkeys/${passkeyId}` 
    const res = await http.delete(url, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with deleting comment, please try again.`))
}
